/**
 * Awaits a given timeout
 * @param {number} wait
 * @returns {Promise<void>}
 */
// eslint-disable-next-line import/prefer-default-export
export const sleep = wait =>
  new Promise(resolve => {
    setTimeout(resolve, wait)
  })
